"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createLabProcedures = createLabProcedures;
const queries_1 = require("../queries");
const shared_1 = require("../../shared");
const messages = {
    labProcedures: {
        id: "dashboard.lab_procedures",
        defaultMessage: "Laborvizsgálatok"
    },
    fvs: {
        id: "dashboard.fvs",
        defaultMessage: "WBC"
    },
    haemoglobin: {
        id: "dashboard.haemoglobin",
        defaultMessage: "HGB"
    },
    plateletCount: {
        id: "dashboard.platelet_count",
        defaultMessage: "TCT"
    },
    gfr: {
        id: "dashboard.gfr",
        defaultMessage: "GFR"
    },
    creatinine: {
        id: "dashboard.creatinine",
        defaultMessage: "KREAT"
    },
    karbamid: {
        id: "dashboard.karbamid",
        defaultMessage: "KARB"
    },
    natrium: {
        id: "dashboard.natrium",
        defaultMessage: "NA"
    },
    potassium: {
        id: "dashboard.potassium",
        defaultMessage: "K"
    },
    got: {
        id: "dashboard.got",
        defaultMessage: "GOT"
    },
    gpt: {
        id: "dashboard.gpt",
        defaultMessage: "GPT"
    },
    ggt: {
        id: "dashboard.ggt",
        defaultMessage: "GGT"
    },
    alkalinePhosphatase: {
        id: "dashboard.alkaline_phosphatase",
        defaultMessage: "AP"
    },
    bilirubinTotal: {
        id: "dashboard.bilirubin_total",
        defaultMessage: "BILI (össz)"
    },
    bilirubinDirect: {
        id: "dashboard.bilirubin_direct",
        defaultMessage: "BILI (direkt)"
    },
    serumGlucose: {
        id: "dashboard.serum_glucose",
        defaultMessage: "VC"
    },
    crp: {
        id: "dashboard.crp",
        defaultMessage: "CRP"
    },
    ldh: {
        id: "dashboard.ldh",
        defaultMessage: "LDH"
    },
    hgbA1C: {
        id: "dashboard.hgb_a1c",
        defaultMessage: "HgbA1C"
    },
    inr: {
        id: "dashboard.inr",
        defaultMessage: "INR"
    },
    pseudocholinesterase: {
        id: "dashboard.pseudocholinesterase",
        defaultMessage: "Pseudocholinesterase"
    },
    prealbumin: {
        id: "dashboard.prealbumin",
        defaultMessage: "Prealbumin"
    },
    tsh: {
        id: "dashboard.tsh",
        defaultMessage: "TSH"
    },
    t3: {
        id: "dashboard.t3",
        defaultMessage: "T3"
    },
    t4: {
        id: "dashboard.t4",
        defaultMessage: "T4"
    },
    coombsIndirect: {
        id: "dashboard.coombs_indirect",
        defaultMessage: "Coombs indirekt"
    },
    coombsDirect: {
        id: "dashboard.coombs_direct",
        defaultMessage: "Coombs direkt"
    },
    ntProBNP: {
        id: "dashboard.nt_pro_bnp",
        defaultMessage: "NT-proBNP"
    },
    bnp: {
        id: "dashboard.bnp",
        defaultMessage: "BNP"
    },
    albumin: {
        id: "dashboard.albumin",
        defaultMessage: "Albumin"
    },
    psa: {
        id: "dashboard.psa",
        defaultMessage: "PSA"
    },
    ama: {
        id: "dashboard.ama",
        defaultMessage: "AMA"
    },
    ana: {
        id: "dashboard.ana",
        defaultMessage: "ANA"
    },
    antiCardiolipinAtIgG: {
        id: "dashboard.anti_cardiolipin_at_igg",
        defaultMessage: "Anti-cardiolipin AT IgG"
    },
    antiCardiolipinAtIgM: {
        id: "dashboard.anti_cardiolipin_at_igm",
        defaultMessage: "Anti-cardiolipin AT IgM"
    },
    antiCardiolipinAtIgA: {
        id: "dashboard.anti_cardiolipin_at_iga",
        defaultMessage: "Anti-cardiolipin AT IgA"
    },
    cryoglobulin: {
        id: "dashboard.cryoglobulin",
        defaultMessage: "Cryoglobulin"
    },
    immunElfoIgG: {
        id: "dashboard.immun_elfo_igg",
        defaultMessage: "ImmunELFO IgG"
    },
    immunElfoIgA: {
        id: "dashboard.immun_elfo_iga",
        defaultMessage: "ImmunELFO IgA"
    },
    immunElfoIgM: {
        id: "dashboard.immun_elfo_igm",
        defaultMessage: "ImmunELFO IgM"
    },
    lkm: {
        id: "dashboard.lkm",
        defaultMessage: "LKM"
    },
    pAnca: {
        id: "dashboard.panca",
        defaultMessage: "pANCA"
    },
    sma: {
        id: "dashboard.sma",
        defaultMessage: "SMA"
    }
};
function createLabProcedures(intl, { events }) {
    const fvs = (0, shared_1.createNumberRecord)(intl, {
        events,
        label: messages.fvs,
        query: queries_1.queries.fvs
    });
    const haemoglobin = (0, shared_1.createNumberRecord)(intl, {
        events,
        label: messages.haemoglobin,
        query: queries_1.queries.haemoglobin
    });
    const plateletCount = (0, shared_1.createNumberRecord)(intl, {
        events,
        label: messages.plateletCount,
        query: queries_1.queries.plateletCount
    });
    const gfr = (0, shared_1.createNumberRecord)(intl, {
        events,
        label: messages.gfr,
        query: queries_1.queries.gfr
    });
    const creatinine = (0, shared_1.createNumberRecord)(intl, {
        events,
        label: messages.creatinine,
        query: queries_1.queries.creatinine
    });
    const karbamid = (0, shared_1.createNumberRecord)(intl, {
        events,
        label: messages.karbamid,
        query: queries_1.queries.karbamid
    });
    const natrium = (0, shared_1.createNumberRecord)(intl, {
        events,
        label: messages.natrium,
        query: queries_1.queries.natrium
    });
    const potassium = (0, shared_1.createNumberRecord)(intl, {
        events,
        label: messages.potassium,
        query: queries_1.queries.potassium
    });
    const got = (0, shared_1.createNumberRecord)(intl, {
        events,
        label: messages.got,
        query: queries_1.queries.got
    });
    const gpt = (0, shared_1.createNumberRecord)(intl, {
        events,
        label: messages.gpt,
        query: queries_1.queries.gpt
    });
    const ggt = (0, shared_1.createNumberRecord)(intl, {
        events,
        label: messages.ggt,
        query: queries_1.queries.ggt
    });
    const alkalinePhosphatase = (0, shared_1.createNumberRecord)(intl, {
        events,
        label: messages.alkalinePhosphatase,
        query: queries_1.queries.alkalinePhosphatase
    });
    const bilirubinTotal = (0, shared_1.createNumberRecord)(intl, {
        events,
        label: messages.bilirubinTotal,
        query: queries_1.queries.bilirubinTotal
    });
    const bilirubinDirect = (0, shared_1.createNumberRecord)(intl, {
        events,
        label: messages.bilirubinDirect,
        query: queries_1.queries.bilirubinDirect
    });
    const serumGlucose = (0, shared_1.createNumberRecord)(intl, {
        events,
        label: messages.serumGlucose,
        query: queries_1.queries.serumGlucose
    });
    const crp = (0, shared_1.createNumberRecord)(intl, {
        events,
        label: messages.crp,
        query: queries_1.queries.crp
    });
    const ldh = (0, shared_1.createNumberRecord)(intl, {
        events,
        label: messages.ldh,
        query: queries_1.queries.ldh
    });
    const hgbA1C = (0, shared_1.createNumberRecord)(intl, {
        events,
        label: messages.hgbA1C,
        query: queries_1.queries.hgbA1C
    });
    const pseudocholinesterase = (0, shared_1.createNumberRecord)(intl, {
        events,
        label: messages.pseudocholinesterase,
        query: queries_1.queries.pseudocholinesterase
    });
    const inr = (0, shared_1.createNumberRecord)(intl, {
        events,
        label: messages.inr,
        query: queries_1.queries.inr
    });
    const prealbumin = (0, shared_1.createNumberRecord)(intl, {
        events,
        label: messages.prealbumin,
        query: queries_1.queries.prealbumin
    });
    const tsh = (0, shared_1.createNumberRecord)(intl, {
        events,
        label: messages.tsh,
        query: queries_1.queries.tsh
    });
    const t3 = (0, shared_1.createNumberRecord)(intl, {
        events,
        label: messages.t3,
        query: queries_1.queries.t3
    });
    const t4 = (0, shared_1.createNumberRecord)(intl, {
        events,
        label: messages.t4,
        query: queries_1.queries.t4
    });
    const ntProBNP = (0, shared_1.createNumberRecord)(intl, {
        events,
        label: messages.ntProBNP,
        query: queries_1.queries.ntProBNP
    });
    const albumin = (0, shared_1.createNumberRecord)(intl, {
        events,
        label: messages.albumin,
        query: queries_1.queries.albumin
    });
    const bnp = (0, shared_1.createNumberRecord)(intl, {
        events,
        label: messages.bnp,
        query: queries_1.queries.bnp
    });
    const coombsDirect = (0, shared_1.createFormattedMessageRecord)(intl, {
        events,
        label: messages.coombsDirect,
        query: queries_1.queries.coombsDirect,
        messages: shared_1.positiveNegativeInProgressMessages
    });
    const coombsIndirect = (0, shared_1.createFormattedMessageRecord)(intl, {
        events,
        label: messages.coombsIndirect,
        query: queries_1.queries.coombsIndirect,
        messages: shared_1.positiveNegativeInProgressMessages
    });
    const psa = (0, shared_1.createNumberRecord)(intl, {
        events,
        label: messages.psa,
        query: queries_1.queries.psa
    });
    const ama = (0, shared_1.createStringRecord)(intl, {
        events,
        label: messages.ama,
        query: queries_1.queries.ama
    });
    const ana = (0, shared_1.createStringRecord)(intl, {
        events,
        label: messages.ana,
        query: queries_1.queries.ana
    });
    const antiCardiolipinAtIgG = (0, shared_1.createNumberRecord)(intl, {
        events,
        label: messages.antiCardiolipinAtIgG,
        query: queries_1.queries.antiCardiolipinAtIgG
    });
    const antiCardiolipinAtIgM = (0, shared_1.createNumberRecord)(intl, {
        events,
        label: messages.antiCardiolipinAtIgM,
        query: queries_1.queries.antiCardiolipinAtIgM
    });
    const antiCardiolipinAtIgA = (0, shared_1.createNumberRecord)(intl, {
        events,
        label: messages.antiCardiolipinAtIgA,
        query: queries_1.queries.antiCardiolipinAtIgA
    });
    const cryoglobulin = (0, shared_1.createStringRecord)(intl, {
        events,
        label: messages.cryoglobulin,
        query: queries_1.queries.cryoglobulin
    });
    const immunElfoIgG = (0, shared_1.createNumberRecord)(intl, {
        events,
        label: messages.immunElfoIgG,
        query: queries_1.queries.immunElfoIgG
    });
    const immunElfoIgA = (0, shared_1.createNumberRecord)(intl, {
        events,
        label: messages.immunElfoIgA,
        query: queries_1.queries.immunElfoIgA
    });
    const immunElfoIgM = (0, shared_1.createNumberRecord)(intl, {
        events,
        label: messages.immunElfoIgM,
        query: queries_1.queries.immunElfoIgM
    });
    const lkm = (0, shared_1.createStringRecord)(intl, {
        events,
        label: messages.lkm,
        query: queries_1.queries.lkm
    });
    const pAnca = (0, shared_1.createStringRecord)(intl, {
        events,
        label: messages.pAnca,
        query: queries_1.queries.pAnca
    });
    const sma = (0, shared_1.createStringRecord)(intl, {
        events,
        label: messages.sma,
        query: queries_1.queries.sma
    });
    const content = (0, shared_1.createSectionContent)([
        fvs,
        haemoglobin,
        plateletCount,
        gfr,
        creatinine,
        karbamid,
        natrium,
        potassium,
        got,
        gpt,
        ggt,
        alkalinePhosphatase,
        bilirubinTotal,
        bilirubinDirect,
        serumGlucose,
        crp,
        ldh,
        hgbA1C,
        pseudocholinesterase,
        inr,
        prealbumin,
        tsh,
        t3,
        t4,
        ntProBNP,
        albumin,
        bnp,
        coombsDirect,
        coombsIndirect,
        psa,
        ama,
        ana,
        antiCardiolipinAtIgG,
        antiCardiolipinAtIgM,
        antiCardiolipinAtIgA,
        cryoglobulin,
        immunElfoIgG,
        immunElfoIgA,
        immunElfoIgM,
        lkm,
        pAnca,
        sma
    ]);
    return (0, shared_1.createSection)(intl, { label: messages.labProcedures, content });
}
